'use strict';

module.exports = {
  Promish: null
};
//# sourceMappingURL=promish.js.map



//////////////////
// WEBPACK FOOTER
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/node_modules/exceljs/dist/es5/utils/promish.js
// module id = ../../../../exceljs/dist/es5/utils/promish.js
// module chunks = vendor